import React from 'react';
// Styles (.ba-track*) live in buildApp.css; import here so they travel with the
// component on both the user and admin (apps.css) detail pages.
import './buildApp.css';

// Ordered lifecycle for the progress tracker (rejected is a terminal off-track
// state, handled separately). The draft step covers active + publish_requested;
// publish_requested additionally lights the Published step as "in review".
export const FLOW = ['pending', 'provisioning', 'active', 'published'];
export const FLOW_LABEL = {
  pending: 'Submitted',
  provisioning: 'Provisioning',
  active: 'In progress',
  published: 'Published',
};
// Map a real status onto its index in FLOW for the tracker.
export const STATUS_FLOW_INDEX = {
  pending: 0,
  approved: 1,
  provisioning: 1,
  active: 2,
  publish_requested: 2,
  published: 3,
};

// Horizontal lifecycle tracker shown on both the user and admin app-detail
// pages so the app's stage is legible at a glance. `rejected` renders as a
// terminal off-track banner.
export default function StatusTracker({ status }) {
  if (status === 'rejected') {
    return (
      <div className="ba-track ba-track--rejected" role="status">
        <span className="ba-track-rejected-dot" aria-hidden="true">✕</span>
        <span>This request was rejected.</span>
      </div>
    );
  }
  const currentIndex = STATUS_FLOW_INDEX[status] ?? 0;
  const isPublished = status === 'published';
  return (
    <ol className="ba-track" aria-label="Request progress">
      {FLOW.map((step, i) => {
        // Published step is only "done" when actually published; while at that
        // index but not published it reads as the current step.
        const done = i < currentIndex || (i === currentIndex && i === FLOW.length - 1 && isPublished);
        const state = done ? 'done' : i === currentIndex ? 'current' : 'todo';
        let label = FLOW_LABEL[step];
        if (step === 'published' && status === 'publish_requested') label = 'In review';
        return (
          <li key={step} className={`ba-track-step is-${state}`}>
            <span className="ba-track-dot" aria-hidden="true">{state === 'done' ? '✓' : i + 1}</span>
            <span className="ba-track-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
